"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiValueRemove = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _ = require("..");

var _Dropdown = require("./Dropdown.style");

var MultiValueRemove = function MultiValueRemove(props) {
  return /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledChipRemove, null, /*#__PURE__*/_react["default"].createElement(_reactSelect.components.MultiValueRemove, props, /*#__PURE__*/_react["default"].createElement(_.Icon, {
    iconName: "Close",
    size: 16,
    className: "mv-close"
  })));
};

exports.MultiValueRemove = MultiValueRemove;